import axios from "axios";

const http = axios.create({
  //baseURL: 'https://m.joywork.dev/',
  timeout: 5000,
});

export default http;